export const getFormattedCurrency = (value: number, currency: string = 'rub') => {
	if (!value) value = 0

	return value.toLocaleString(currency, {
		style: 'currency',
		currency
	})
}
